export const requestNotificationPermission = async () => {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'denied';
  return Notification.requestPermission();
};

export const sendLocalNotification = async (title: string, options?: NotificationOptions) => {
  const requestedAt = Date.now();
  if (typeof window === 'undefined' || !('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  try {
    // Safari installed web apps deliver through their service-worker registration.
    // Do not wait on `ready`, which can remain pending without a registration.
    const registration = await navigator.serviceWorker?.getRegistration();
    const age = Date.now() - requestedAt;
    if (age < 0 || age > 10000) return;
    if (registration) await registration.showNotification(title, options);
    else new Notification(title, options);
  } catch {
    // Permission, Focus mode and platform delivery must not block timekeeping.
  }
};
